import { TModifierState } from './types';

export const INITIAL_MODIFIER_VALUES: TModifierState = {
  shift: false,
  symbols: false,
  lock: false,
  numberPad: false,
};
